module.exports = __webpack_public_path__ + "slide2.jpg?36a464fad45304c3596519ba2f9f2b0c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/slide2.jpg
// module id = 319
// module chunks = 0